export default "__VITE_ASSET__EFxu_Yrz__"